var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { defaultProps } from './defaults';
import FieldContext from './FieldContext';
import useForm from './useForm';
import { FormTag } from '../../Utils/AtomicTag';
import Field from './Field';
var Form = function (props) {
    var form = props.form, children = props.children, labelPosition = props.labelPosition, formGroupTitle = props.formGroupTitle, className = props.className, style = props.style, onFinish = props.onFinish, onFinishFailed = props.onFinishFailed, starPositon = props.starPositon, rest = __rest(props, ["form", "children", "labelPosition", "formGroupTitle", "className", "style", "onFinish", "onFinishFailed", "starPositon"]);
    var _a = __read(useForm(), 1), formInstance = _a[0];
    var setCallback = formInstance.setCallback, submit = formInstance.submit;
    setCallback({
        onFinish: onFinish,
        onFinishFailed: onFinishFailed,
    });
    var positionObj = {
        Top: 'form-layout-top',
        Left: 'form-layout-left',
        Right: 'form-layout-right',
    };
    var renderField = function () {
        formInstance.starPositon = starPositon;
        return React.createElement(FieldContext.Provider, { value: formInstance }, children);
    };
    return (React.createElement(FormTag, __assign({ name: Form.NAME, className: "form " + positionObj[labelPosition] + " " + className, onSubmit: function (e) {
            e.preventDefault();
            submit();
        } }, rest), formGroupTitle ? (React.createElement("fieldset", { className: "legao-form-group" },
        React.createElement("legend", { className: "legao-form-title" },
            React.createElement("h3", null, formGroupTitle)),
        renderField())) : (renderField())));
};
Form.defaultProps = defaultProps;
Form.NAME = 'form';
Form.Item = Field;
export default Form;
